import axios from '@/utils/axios'

enum EVENT_NODE_TYPE {
  '首页浏览' = 'BROWSE_HOME_PAGE',
  '详情页浏览' = 'BROWSE_DETAIL_PAGE',
  '用户注册' = 'REGISTER',
  '用户第三方登录' = 'THIRD_PARTY_LOGIN',
  '用户直接登录' = 'DIRECT_LOGIN',
  '使用流程引导' = 'IGUIDANCE_SERVICE',
  '预问诊查询' = 'DEPT_SERVICE',
  '症状自查查询' = 'SYMPTOM_SERVICE',
  '疾病知识查询' = 'DISEASE_SERVICE',
  '药品知识查询' = 'MEDICINE_SERVICE',
  '报告解读查询' = 'TEST_SERVICE',
}

interface Event {
  nodeType: EVENT_NODE_TYPE
  nodeName?: string
  page?: string
  pageName?: string
  lastPage?: string
  lastPageName?: string
  ip?: string
  url?: string
  reqParam?: string
  resParam?: string
  remark?: string
}

const trackEvent = (event: Event) => {
  axios.post('/i-guidance/h5/node', event)
}

export {
  EVENT_NODE_TYPE,
  trackEvent
}
